import React from 'react';
import { MapPin } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { content } from '../mock';

export const PropertyDescription = () => {
  const { language } = useLanguage();
  const t = content[language];

  return (
    <div className="space-y-8">
      {/* Title and Location */}
      <div className="space-y-3 pb-8 border-b">
        <div className="flex items-center gap-2 text-gray-600">
          <MapPin className="h-5 w-5" />
          <span className="text-lg">{t.propertyLocation}</span>
        </div>
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900">
          {t.propertyName}
        </h1>
        {/* Property Stats */}
        <p className="text-base text-gray-700 pt-1">
          {t.propertyStats}
        </p>
      </div>

      {/* Description */}
      <div className="pb-8 border-b">
        <h2 className="text-2xl font-semibold mb-4 text-gray-900">{t.descriptionTitle}</h2>
        <p className="text-gray-700 whitespace-pre-line leading-relaxed">
          {t.description}
        </p>
      </div>

      {/* Features */}
      <div className="pb-8 border-b">
        <h2 className="text-2xl font-semibold mb-4 text-gray-900">{t.propertyFeatures}</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {t.features.map((feature, index) => (
            <div key={index} className="flex items-start gap-3">
              <svg className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              <span className="text-gray-700">{feature}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
